/* @flow */

import React from 'react';
import styled from 'styled-components';
import FlexBox from '../FlexBox';
import {
  StyledModal,
} from './TransferModal';
import BorrowPanel from './BorrowPanel';
import {
  fetchMaxBorrowAmount,
} from '../../actions/actionsSet/margin';
import { getLabel } from '../../utils/i18n';
import { formatBigNumber } from '../../utils/number';

const TabItem = styled.span`
  display: inline-block;
  width: 50%;
  color: ${({ isActive }) => isActive ? '#212833;' : '#848E9C'};
  cursor: pointer;
`;
const Spin = styled.span`
  position: absolute;
  width: 50%;
  height: 2px;
  left: 0;
  transform: ${({ activeTab }) => activeTab === 'Borrow' ? 'translate3d(0,0,0)' : 'translate3d(100%,0,0)'};
  bottom: -2px;
  background: #F0B90B;
  transition: transform .25s linear;
`;
const PanelContainer = styled.div`
  overflow: hidden;
`;
const PanelWrapper = styled(FlexBox)`
  width: 200%;
  height: 398px;
  transform: ${({ activeTab }) => activeTab === 'Borrow' ? 'translate3d(0,0,0)' : 'translate3d(-50%,0,0)'};
  transition: transform .3s ease-in-out;
`;
const Tab = ({ i18n, activeTab, handleTabChange }: Object) => (
  <div>
    <TabItem
      key="borrow"
      isActive={activeTab === 'Borrow'}
      onClick={() => handleTabChange('Borrow')}
    >
      {getLabel('exchange-borrowRepayModal-borrow', i18n)}
    </TabItem>
    <TabItem
      key="repay"
      isActive={activeTab === 'Repay'}
      onClick={() => handleTabChange('Repay')}
    >
      {getLabel('exchange-borrowRepayModal-repay', i18n)}
    </TabItem>
    <Spin activeTab={activeTab} />
  </div>
);

type Props = {
  i18n: Object,
  userAssets: Array<Object>,
  callback: Function,
}
type States = {
  visible: bool,
  activeTab: string,
  curRepayAsset: Object,
  curBorrowAsset: Object,
  curRepayMaxAmount: string,
  curBorrowMaxAmount: string
}
export default class BorrowRepayModal extends React.PureComponent<Props, States> {
  state = {
    visible: false,
    activeTab: 'Borrow',
    curBorrowAsset: {},
    curRepayAsset: {},
    curBorrowMaxAmount: '0',
    curRepayMaxAmount: '0',
  }

  showModal = async (asset: Object) => {
    const { isBorrowable } = asset;
    this.setState({
      visible: true,
      curRepayAsset: asset,
      curBorrowAsset: asset,
    });
    const curBorrowMaxAmount = isBorrowable ? await this.getMaxAmount('Borrow', asset) : '0';
    const curRepayMaxAmount = await this.getMaxAmount('Repay', asset);
    this.setState({
      curRepayMaxAmount,
      curBorrowMaxAmount,
    });
  }

  getMaxAmount = async (type: string, { free, asset, totalDebt }: Object) => {
    let amount = '0';
    if (type === 'Borrow') {
      amount = await fetchMaxBorrowAmount(asset);
    } else {
      amount = formatBigNumber(`${Math.min(free, totalDebt)}`, 8);
    }
    return amount;
  }

  _handleTabChange = (activeTab: string) => {
    this.setState({
      activeTab,
    });
  }

  _handleSelectChange = async (type: string, asset: Object) => {
    const key = type === 'Borrow' ? 'curBorrow' : 'curRepay';
    const amount = await this.getMaxAmount(type, asset);
    this.setState({
      [`${key}Asset`]: asset,
      [`${key}MaxAmount`]: amount,
    });
  }

  _closeModal = (reload: bool = false) => {
    this.setState({
      visible: false,
    });
    this.props.callback(reload);
  }

  render() {
    const { i18n, userAssets } = this.props;
    const {
      activeTab,
      curRepayAsset,
      curBorrowAsset,
      curRepayMaxAmount,
      curBorrowMaxAmount,
    } = this.state;
    const {
      visible,
    } = this.state;
    return (
      <StyledModal
        footer={null}
        noPadding={true}
        centered={true}
        visible={visible}
        title={
          <Tab
            i18n={i18n}
            activeTab={activeTab}
            handleTabChange={this._handleTabChange}
          />
        }
        onCancel={() => this._closeModal()}
      >
        <PanelContainer>
          <PanelWrapper activeTab={activeTab}>
            <BorrowPanel
              i18n={i18n}
              key={`borrow_${curBorrowAsset.asset}`}
              panelType="Borrow"
              initAsset={curBorrowAsset}
              maxAmount={curBorrowMaxAmount}
              userAssets={userAssets}
              closeModal={this._closeModal}
              handleSelectChange={this._handleSelectChange}
            />
            <BorrowPanel
              i18n={i18n}
              key={`repay_${curRepayAsset.asset}`}
              panelType="Repay"
              initAsset={curRepayAsset}
              maxAmount={curRepayMaxAmount}
              userAssets={userAssets}
              closeModal={this._closeModal}
              handleSelectChange={this._handleSelectChange}
            />
          </PanelWrapper>
        </PanelContainer>
      </StyledModal>
    );
  }
}
